import React, {useMemo, useState} from "react";
import {Col, Row} from "reactstrap";
import {InputForm} from "../../base/input/input";
import Button from "../../base/button/button";
import Form from "../../base/form";
import AddQuoteDialog from "../../dialogs/add-quote";
import {DropdownForm} from "../../base/dropdown/dropdown";
import {Paper} from "@mui/material";
import CustomerAutocomplete from "../../text-fields/autocomplete/customer-autocomplete";
import {MuiRFF, Yup} from '../../form';

const schema = Yup.object().shape({
    customer: Yup.mixed().nullable(),
    keyword: Yup.string().nullable(),
    status: Yup.mixed().nullable(),
});

const validate = MuiRFF.makeValidate(schema);
const required = MuiRFF.makeRequired(schema);

const DamageControlTransactionsSearchSection = ({searchData, statusesList}) => {
    const [createQuoteDialog, setCreateQuoteDialog] = useState(false);

    const initialValues = useMemo(() => ({
        ...(searchData.filters ?? {}),
    }), [searchData.filters])
    /**
     * Changes the query of the url to the query containing the searched values so that the list pages of orders can
     * use them and search related orders.
     * @param values {any} form values
     */
    const onSubmit = (values) => {
        searchData.setFilters({
            keyword: values.keyword,
            status: values.status,
            customer: values.customer,
        });
    }

    return (
        <>
            <Form
                onSubmit={onSubmit}
                validate={validate}
                initialValues={initialValues}
                render={({submitting, values, form}) => {
                    const colClassName = 'px-2 mb-4';
                    return (
                        <Row className='no-gutters align-items-center justify-content-center'>
                            <Col xs={12} className={colClassName}>
                                <Paper className={'p-2'}>
                                    <CustomerAutocomplete
                                        form
                                        name={'customer'}
                                        label={'Customer'}
                                        placeholder={'Search for customer...'}
                                        fullWidth
                                        textFieldProps={{
                                            variant: 'filled',
                                            InputProps: {disableUnderline: true, sx: {borderRadius: 1}},
                                        }}
                                    />
                                </Paper>
                            </Col>

                            <Col xs={6} className={colClassName}>
                                <InputForm
                                    onChange={(val) => form.change('keyword', val)}
                                    value={values?.keyword ?? ''}
                                    label={'Keywords'}
                                    name={'keyword'}
                                    type={'text'}
                                    required={required.keyword}
                                />
                            </Col>
                            <Col xs={6} className={colClassName}>
                                <DropdownForm
                                    label={'Status'}
                                    name={'status'}
                                    required={required.status}
                                    data={statusesList?.map(e => ({
                                        value: e,
                                        label: e.title,
                                        id: e.id
                                    })) ?? []}
                                />
                            </Col>
                            <Col xs={12}
                                 className='px-3 mt-2 align-items-center row no-gutters justify-content-center align-items-center'>
                                <Button
                                    disabled={!!submitting}
                                    type={'submit'}
                                    variant={'contained'}
                                    color={'primary'}
                                    className='py-3 px-8'
                                >
                                    Search
                                </Button>
                            </Col>
                        </Row>
                    );
                }}
            />
            <AddQuoteDialog
                open={createQuoteDialog}
                setOpen={setCreateQuoteDialog}
            />
        </>
    );
}

export default DamageControlTransactionsSearchSection;
